{
  "quoteStale": {
    "title": "Giá đã được cập nhật",
    "regionLabel": "Giá đã được cập nhật — cần xác nhận lại",
    "body": {
      "PRICE_CHANGED": "Giá sản phẩm đã thay đổi kể từ lúc báo giá. Kiểm tra tổng mới bên dưới trước khi thanh toán.",
      "SHIPPING_CHANGED": "Phí vận chuyển đã thay đổi kể từ lúc báo giá. Kiểm tra tổng mới bên dưới trước khi thanh toán.",
      "TAX_CHANGED": "Thuế đã thay đổi kể từ lúc báo giá. Kiểm tra tổng mới bên dưới trước khi thanh toán.",
      "EXPIRED": "Báo giá của bạn đã hết hạn. Kiểm tra tổng mới bên dưới trước khi thanh toán.",
      "CART_CHANGED": "Đơn hàng đã thay đổi kể từ lúc báo giá. Kiểm tra tổng mới bên dưới trước khi thanh toán.",
      "CONSUMED": "Báo giá này đã được thanh toán.",
      "MISSING_SNAPSHOT": "Báo giá của bạn không còn hiệu lực. Kiểm tra tổng mới bên dưới trước khi thanh toán.",
      "fallback": "Giá đã thay đổi kể từ lúc báo giá. Kiểm tra tổng mới bên dưới trước khi thanh toán."
    },
    "reason": {
      "PRICE_CHANGED": "Giá sản phẩm đã thay đổi",
      "SHIPPING_CHANGED": "Phí vận chuyển đã thay đổi",
      "TAX_CHANGED": "Thuế đã thay đổi",
      "EXPIRED": "Báo giá đã hết hạn",
      "CART_CHANGED": "Nội dung đơn hàng đã thay đổi",
      "CONSUMED": "Đã thanh toán",
      "MISSING_SNAPSHOT": "Báo giá không còn hiệu lực"
    },
    "reviewCart": "Xem lại giỏ",
    "confirmNewPrice": "Xác nhận giá mới {{total}}",
    "confirmNewPriceBusy": "Đang xác nhận…",
    "rejectedLinesNote": "Một số sản phẩm không còn được báo giá. Hãy xem lại giỏ trước khi thanh toán.",
    "requestId": "Mã tham chiếu hỗ trợ: {{id}}",
    "previousAmount": "Giá cũ {{amount}}",
    "newAmount": "Giá mới {{amount}}"
  },
  "breakdown": {
    "subtotal": "Tạm tính",
    "shipping": "Vận chuyển",
    "shippingWithService": "Vận chuyển ({{service}})",
    "tax": "Thuế",
    "taxWithRate": "Thuế ({{rate}}%)",
    "total": "Tổng cộng",
    "changedRow": "Đã thay đổi"
  },
  "shippingUnavailable": {
    "regionLabel": "Không thể vận chuyển — đã khoá thanh toán",
    "title": "Không thể vận chuyển",
    "body": "Không có dịch vụ vận chuyển nào phục vụ điểm đến này. Hãy đổi địa chỉ giao hàng để tiếp tục.",
    "changeAddress": "Đổi địa chỉ",
    "payDisabled": "Thanh toán"
  },
  "checkout": {
    "totalPending": "Đang lấy giá mới nhất…",
    "totalUnavailable": "Chưa có giá",
    "totalAnnounced": "Tổng cộng đã cập nhật: {{total}}",
    "payCta": "Thanh toán {{total}}",
    "payCtaNoTotal": "Thanh toán",
    "payBusy": "Đang xử lý…",
    "payBlocked": {
      "EMPTY_CART": "Thêm ít nhất một sản phẩm trước khi thanh toán.",
      "PREVIEW_LOADING": "Đang chờ giá mới nhất…",
      "PREVIEW_ERROR": "Chưa lấy được giá mới nhất. Hãy thử lại trước khi thanh toán.",
      "CART_DIRTY": "Đơn hàng vừa thay đổi — đang chờ giá mới.",
      "NO_QUOTE": "Đơn hàng này chưa được tính giá.",
      "QUOTE_EXPIRED": "Báo giá này đã hết hạn và sẽ được làm mới ngay.",
      "REJECTED_LINES": "Một số sản phẩm không tính được giá. Hãy xem lại giỏ trước khi thanh toán."
    },
    "previewFailedTitle": "Chưa có giá",
    "previewFailedBody": "Chưa lấy được giá mới nhất cho đơn hàng này. Hãy thử lại để tiếp tục.",
    "retry": "Thử lại",
    "walletShortfall": "Ví của bạn còn thiếu {{shortfall}}. Hãy nạp thêm rồi thử lại.",
    "rejectedLinesTitle": "Những sản phẩm này không tính được giá",
    "rejectedLine": "{{variant}} — {{reason}}",
    "rejectedReason": {
      "VARIANT_NOT_FOUND": "Phiên bản không còn tồn tại",
      "BLUEPRINT_NOT_FOUND": "Sản phẩm không còn tồn tại",
      "PRODUCT_NOT_SELLABLE": "Sản phẩm này chưa được mở bán",
      "UNPRICED_VARIANT": "Phiên bản này chưa được đặt giá",
      "INACTIVE_VARIANT": "Phiên bản này đã ngừng kinh doanh"
    },
    "toast": {
      "orderConfirmed": "Đã thanh toán đơn hàng",
      "orderConfirmedDetail": "Đã trừ {{total}} từ {{source}} của bạn.",
      "fundingSource": {
        "wallet": "ví",
        "credit": "hạn mức tín dụng"
      },
      "confirmInvalid": "Chưa gửi được yêu cầu thanh toán — hãy kiểm tra đơn hàng rồi thử lại.",
      "walletInsufficient": "Số dư không đủ để thanh toán đơn hàng này.",
      "orderForbidden": "Bạn không có quyền truy cập đơn hàng này.",
      "orderNotFound": "Đơn hàng này không còn tồn tại.",
      "sessionExpired": "Phiên đăng nhập đã hết hạn — vui lòng đăng nhập lại.",
      "rateLimited": "Bạn thao tác quá nhanh. Hãy thử lại sau {{seconds}} giây.",
      "alreadyPaid": "Đơn hàng này đã được thanh toán.",
      "keyReuse": "Lượt thanh toán đó không còn hiệu lực — hãy tải lại và thử lại.",
      "confirmFailed": "Thanh toán thất bại. Vui lòng thử lại."
    }
  },
  "_vgBinding": "vg-binding: P4.12.D-17 · vg-binding: P4.12.D-20 · vg-binding: P4.12.D-22 · vg-binding: INTERFACE-STANDARDS:error-shape — QuoteStaleBanner copy: re-consent title/body per QUOTE_STALE reason, reason LABELS (wire enum VALUE stays English), delta-table row labels and the SHIPPING_UNAVAILABLE variant. en/vi/fr, equal key counts [task-16] · [task-15] vg-binding: P4.12.D-19 · vg-binding: P4.12.D-21 · vg-binding: P4.12.D-33 · vg-binding: P4.12.D-35 · vg-binding: INTERFACE-STANDARDS:error-shape — adds the `checkout.*` block: breakdown skeleton/empty labels, the D-21 PayButton CTA + per-reason blocked labels (wire enum VALUE stays English), the rejected-line reasons, the wallet-shortfall notice and the confirm toast catalog (API-CONTRACTS/post-orders-id-confirm.md BLOCK 5 toast_text). en/vi/fr, equal key counts"
}
